import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { AppRoutes } from "routes/AppRoutes";
import { AuthProvider } from "context";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter basename="/">
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  </BrowserRouter>
);
